import PropTypes from "prop-types"
import React, { createContext } from "react"

import Heading from "src/components/Heading"

import InvoiceList from "./InvoiceList"
import InvoiceTotals from "./InvoiceTotals"

export const BoaterInvoicesContext = createContext(null)

const Invoices = ({ invoiceFilters, translations }) => {
  return (
    <BoaterInvoicesContext.Provider
      value={{
        invoiceFilters,
        translations,
      }}
    >
      <div
        id="account-invoices-and-payments-index"
        className="container text-base"
      >
        <div className="my-6">
          <Heading.PageTitle>{translations.pageHeading}</Heading.PageTitle>
          <div className="text-muted my-2 text-base">
            {translations.pageSubheading}
          </div>
        </div>
        <div className="body flex grid gap-6 sm:grid-cols-1 lg:grid-cols-4">
          <div className="sm:col-span-1 lg:col-span-1">
            <InvoiceTotals />
          </div>
          <div className="sm:col-span-1 lg:col-span-3">
            <InvoiceList />
          </div>
        </div>
      </div>
    </BoaterInvoicesContext.Provider>
  )
}

const multiSelectFilterShape = PropTypes.shape({
  label: PropTypes.string.isRequired,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      value: PropTypes.string.isRequired,
    })
  ),
}).isRequired

Invoices.propTypes = {
  invoiceFilters: PropTypes.shape({
    dueDate: PropTypes.shape({
      label: PropTypes.string.isRequired,
    }).isRequired,
    marina: multiSelectFilterShape,
    status: multiSelectFilterShape,
    type: multiSelectFilterShape,
  }).isRequired,
  translations: PropTypes.shape({
    autopayEnabled: PropTypes.string.isRequired,
    current: PropTypes.string.isRequired,
    pageHeading: PropTypes.string.isRequired,
    pageSubheading: PropTypes.string.isRequired,
    payNow: PropTypes.string.isRequired,
    none: PropTypes.string.isRequired,
    upcoming: PropTypes.string.isRequired,
  }).isRequired,
}

export default Invoices
